import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-159d501a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-3" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = {
  key: 0,
  class: "p-col-2 container-image"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-spin mdi-loading",
  style: {"fontSize":"5rem"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "p-col-2 container-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "image-overlay" }
const _hoisted_10 = {
  key: 2,
  class: "p-col-2 container-image"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-spin mdi-loading",
  style: {"fontSize":"5rem"}
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "p-col-2 container-image"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "image-overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemThemeUploadForm = _resolveComponent("SystemThemeUploadForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('Squeeze.System.ImageUploadDescription')), 1)
    ]),
    _createVNode(_component_SystemThemeUploadForm, {
      selectedFiles: _ctx.files,
      onFileUploader: _ctx.fileUploader,
      onDeleteThemeFile: _ctx.deleteThemeFile
    }, null, 8, ["selectedFiles", "onFileUploader", "onDeleteThemeFile"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Squeeze.System.CurrentImages')), 1)
      ]),
      (_ctx.loadingLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.urlClientLogo,
              alt: "Client Logo",
              class: "image"
            }, null, 8, _hoisted_8),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Squeeze.System.LoginLogoImage')), 1)
          ])),
      (_ctx.loadingLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _ctx.urlClientBackground,
              alt: "Background Image",
              class: "image"
            }, null, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('Squeeze.System.LoginBackgroundImage')), 1)
          ]))
    ])
  ], 64))
}